import { isUndefined } from "lodash";
import React from "react";
import { FindingSummary } from "types/api/findingSummary";
import { DerivedAttribute } from "types/tenantConfig";
import { CellRenderers } from "utils/tableUtils";

import { ACTableColumnType } from "ac-components/ACTable/ACTable";

export default function useDerivedAttributesColumns(
  derivedAttributes: DerivedAttribute[] | undefined,
) {
  const customColumns: ACTableColumnType<FindingSummary>[] = [];
  if (!isUndefined(derivedAttributes)) {
    derivedAttributes.forEach((col) => {
      customColumns.push({
        title: col.columnName,
        dataIndex: col.id,
        key: col.id,
        render: (value, record) => {
          const finalValue = CellRenderers.VALUE_OR_NA(
            record.derivedAttributeMap?.[col.id],
          );
          return (
            <div title={finalValue}>
              {finalValue.length > 256
                ? finalValue.substr(0, 256) + "..."
                : finalValue}
            </div>
          );
        },
        width: 150,
      });
    });
  }
  return customColumns;
}
